// extracted by mini-css-extract-plugin
export default {"root":"T2wc88"};